<template>
  <div class="home">
    <div class="head-title">合规监控</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>1、企业根据自身需求设置触发违禁关键词，并设置需要监控的对象。</p>
          <p>
            2、开启监控对象后，将会对该员工会话内容中出现的关键词进行自动预警。
          </p>
          <p>
            3、删除事件为员工主动删除客户，详细记录客户或员工删除或被删除的名称、时间等内容，删除客户后24小时内为挽留期，企业可根据后台预警及时做出弥补措施。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="body_html">
      <div class="">
        <div class="tianjia">
          <div>
            <el-form label-width="12.0rem">
              <el-button
                @click="sensitiven()"
                :class="sensitive == true ? 'dianji' : 'greyC'"
                style="border-radius: .8rem .8rem 0  0;"
                >敏感词触发</el-button
              >
              <el-button
                @click="delen()"
                :class="dele == true ? 'dianji' : 'greyC'"
                style="border-radius: .8rem .8rem 0  0;margin: 0"
                >删除事件</el-button
              >
            </el-form>
          </div>
          <div class="mMain">
            <div class="buttom" :class="sensitive == true ? 'cc' : 'yc'">
              <el-form label-width="12.0rem" class="navs-t">
                <span
                  @click="triggern()"
                  :class="trigger == true ? 'active' : 'falsell'"
                  >触发记录</span
                >
                <span
                  @click="monitoringn()"
                  :class="monitoring == true ? 'active' : 'falsell'"
                  >监控对象设置</span
                >
                <span
                  @click="sensitivityn()"
                  :class="sensitivity == true ? 'active' : 'falsell'"
                  >敏感词关键词</span
                >
              </el-form>
            </div>
            <div :class="sensitive == true ? 'xs' : 'yc'" class="abc">
              <div v-if="trigger == true" class="tongyi">
                <triggern></triggern>
              </div>
              <div v-if="monitoring == true" class="tongyi">
                <monitoring></monitoring>
              </div>
              <div v-if="sensitivity == true" class="tongyi">
                <sensitivityn></sensitivityn>
              </div>
            </div>
            <div class="bac" v-if="dele == true">
              <dele></dele>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import md5 from "js-md5";
import triggern from "../../components/compliance/triggern.vue";
import sensitivityn from "../../components/compliance/sensitivityn.vue";
import monitoring from "../../components/compliance/monitoring.vue";
import dele from "../../components/compliance/dele.vue";
export default {
  data() {
    return {
      tooken: "",
      sensitive: true, //敏感词触发
      dele: false, //删除事件
      trigger: true, //触发记录
      monitoring: false, //监控对象
      sensitivity: false, //敏感词关键词
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      // // // console.log(userinfo);
      this.tooken = userinfo;
    }
    // this.userTable();
  },
  components: {
    triggern,
    sensitivityn,
    monitoring,
    dele,
  },
  methods: {
    //敏感词触发
    sensitiven() {
      this.sensitive = true;
      this.dele = false;
    },
    //删除事件
    delen() {
      this.sensitive = false;
      this.dele = true;
    },
    // 触发记录
    triggern() {
      this.trigger = true; //触发记录
      this.monitoring = false; //监控对象
      this.sensitivity = false; //敏感词关键词
      // this.userTable();
    },
    //监控对象
    monitoringn() {
      this.trigger = false; //触发记录
      this.monitoring = true; //监控对象
      this.sensitivity = false; //敏感词关键词
    },
    //敏感词关键词
    sensitivityn() {
      this.trigger = false; //触发记录
      this.monitoring = false; //监控对象
      this.sensitivity = true; //敏感词关键词
    },
    userTable() {
      this.axios
        .post(
          "/home/role/getSessionPrivilegeList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style scoped>
.greyC {
  color: #888;
  background-color: #eee;
  border-radius: 1.0rem 1.0rem .0rem .0rem;
  font-size: 1.8rem;
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}

.wei_body {
  /* margin-top: 1.0rem; */
  width: 100%;
  /* height: 94.2rem; */
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  /* overflow-y: auto; */
}
.tianjia {
  width: 100%;
  height: 80%;
}
.tianjia > main {
  font-size: 2.6rem;
  /* margin-bottom: 4.0rem; */
}
.xs {
  display: inline-block;
}
.cc {
  border-bottom: .1rem solid #eee;
}
.yc {
  display: none;
}

.navs-t > span {
  display: inline-flex;
  margin-right: 5.0rem;
  padding-bottom: 1.8rem;
  cursor: pointer;
  font-weight: 500;
  font-size: 1.8rem;
  color: #19273c;
}
.navs-t .active {
  color: #2890dd;
  border-bottom: .2rem solid;
}

.falsell {
  color: rgb(168, 168, 168);
  background-color: white;
}

.abc {
  margin-top: 2.0rem;
  width: 100%;
  height: 100%;
}
.bac {
  margin-top: 3.0rem;
  width: 100%;
  height: 100%;
  background: rgba(250, 253, 255, 1);
}
.tongyi {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss" scoped>

.dianji {
  box-shadow: .0rem .2rem 4.0rem .0rem #eeeeee;
  border-radius: 1.0rem 1.0rem .0rem .0rem;
  color: #49B372 !important;
  background: #fff !important;
  box-shadow: none;
  border: none;
  font-size: 2.1rem;
  border-radius: 0;
  padding: 0;
  width: 20.0rem;
  height: 7.0rem;
  font-weight: 700;
}
.greyC{
  font-weight: 500;
  font-size: 2.1rem;
  background-color: #f8f8f8;
  border: none;
  border-radius: 0;
  padding: 0;
  width: 20.0rem;
  height: 7.0rem;
}
.greyC:hover,.dianji:hover{
  color: #49B372;
  background-color:#F6FFFA;
  border: 0 !important;
}
.navs-t .active[data-v-9ec556b0] {
  color: #49B372;
}

.navs-t > span[data-v-9ec556b0] {
  margin-right: 6.0rem;
  padding-bottom: 2.7rem;
}
.abc{
  margin-top: 3.0rem;
}
.mMain{
  background-color:#fff;
  border-radius: 0 .8rem .8rem .8rem ;
}
</style>
